import { Box, Container, Heading, Text } from '@chakra-ui/react';
import Header from '../partials/common/header/header';
import Footer from '../partials/common/footer/footer';

function VirtualToursPage() {
    return (
        <>
            <Header />
            <Container py={20} px={{ base: 18, md: 28 }} width={"100%"} maxW={"100%"} centerContent>
                <Heading>Virtual Tours</Heading>
                <Box mt={10} textAlign="center">
                    <Text fontSize="lg">
                        Welcome to the future of travel! Our Virtual Tours feature is currently under development.
                    </Text>
                    <Text mt={4}>
                        Soon, you will be able to explore breathtaking destinations from the comfort of your home. Get ready for an immersive experience that will transport you to the world's most amazing places.
                    </Text>
                    <Text mt={4}>
                        Stay tuned for updates!
                    </Text>
                </Box>
            </Container>
            <Footer />
        </>
    );
}

export default VirtualToursPage;